const KEY = "vybe_cookie_consent";

export function getConsent() {
  return localStorage.getItem(KEY);
}

export function setConsent(value) {
  localStorage.setItem(KEY, value);
}
